// Tela de DetailsProposal
// - Na tela de financeiro, o usuario vai abrir um formulario para enviar uma proposta
// - O formulario vai ter os campos:
//    1 - Info precatório (CPF/CNPJ)
//    2 - Valor Presente do Precatório
//    3 - Valor proposto (desembolso)
//    4 - Comissão Advogados
//    5 - Comissão do intermediário
//    [Salvar tudo isso em uma tabela de Proposal]
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import ErrorPage from "../pages/ErrorPage";
import "react-toastify/dist/ReactToastify.css";
import api from "../api";
import { Eye, EyeOff } from "lucide-react";

export default function DetailsProposal() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [comissaoAdvogados, setComissaoAdvogados] = useState("");
  const [comissaoIntermediario, setComissaoIntermediario] = useState("");
  const [valorFinal, setValorFinal] = useState("");
  const [valorProposto, setValorProposto] = useState("");

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchLog = async () => {
      try {
        setLoading(true);
        const res = await api.get(`/AI/${id}`);
        console.log(res.data);
        setLog(res.data);
        setError(null);
      } catch {
        setError("Erro ao carregar os detalhes.");
      } finally {
        setLoading(false);
      }
    };

    fetchLog();
  }, [id]);

  let cleanedJson = log?.response;
  if (typeof cleanedJson === "string") {
    cleanedJson = cleanedJson.replace(/```json|```/g, "").trim();
  }
  let data = {};
  try {
    data = JSON.parse(cleanedJson);
  } catch (e) {
    console.error("Erro ao fazer parse do JSON:", e);
    data = {};
  }

  const formatCurrency = (value) => {
    const onlyDigits = value.replace(/\D/g, "");
    const numericValue = parseFloat(onlyDigits) / 100;
    return numericValue.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });
  };

  const handleCurrencyChange = (setter) => (e) => {
    const value = e.target.value;
    setter(formatCurrency(value));
  };

  const handleEnviar = async () => {
    try {
      await api.put(`/proposal/gerar/${id}`);
      toast.success("Proposta gerada com sucesso!");
    } catch (error) {
      toast.error("Erro ao gerar proposta.");
    }

    navigate(`/precatorios`);
  };

  const parseCurrency = (maskedValue) => {
    if (!maskedValue) return 0;
    const clean = maskedValue.replace(/[R$\s.]/g, "").replace(",", ".");
    return parseFloat(clean) || 0;
  };

  useEffect(() => {
    const soma =
      parseCurrency(valorProposto) -
      parseCurrency(comissaoAdvogados) -
      parseCurrency(comissaoIntermediario);

    const formatted = soma.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
    });

    setValorFinal(formatted);
  }, [
    comissaoAdvogados,
    comissaoIntermediario,
    valorProposto,
    data?.valorPresente?.valorOferta,
  ]);

  return (
    <div>
      <div className="auth-card-container">
        <div className="auth-card-proposal">
          <h2>Proposta</h2>

          {/*<div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Nome do Arquivo:
            </label>
            <input className="input" value={data.nameFile} readOnly />
          </div>*/}

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Número do Processo Principal:
            </label>
            <input
              className="input"
              value={data.numeroProcessoPrincipal}
              readOnly
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Valor bruto do precatório:
            </label>
            <input
              className="input"
              value={`R$ ${
                data.composicaoValorRequisitado?.totalBruto?.toLocaleString() ||
                "N/A"
              }`}
              readOnly
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Valor presente líquido:
            </label>
            <input
              className="input"
              value={`R$ ${
                typeof data.valorPresente?.valorAtualizado?.toNumber ===
                "function"
                  ? data.valorPresente.valorAtualizado
                      .toNumber()
                      .toLocaleString("pt-BR", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                      })
                  : Number(
                      data.valorPresente?.valorAtualizado || 0
                    ).toLocaleString("pt-BR", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })
              }`}
              readOnly
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Valor de desembolso:
            </label>
            <input
              className="input"
              value={valorProposto}
              onChange={handleCurrencyChange(setValorProposto)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Comissão Advogados:
            </label>
            <input
              className="input"
              value={comissaoAdvogados}
              onChange={handleCurrencyChange(setComissaoAdvogados)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Comissão dos Intermediários:
            </label>
            <input
              className="input"
              value={comissaoIntermediario}
              onChange={handleCurrencyChange(setComissaoIntermediario)}
            />
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "2rem",
            }}
          >
            <label style={{ width: "40%", marginBottom: "1rem" }}>
              Valor a ser proposto:
            </label>
            <input className="input" value={valorFinal} readOnly />
          </div>

          <button className="button button-azul" onClick={handleEnviar}>
            Enviar
          </button>
        </div>
      </div>
    </div>
  );
}
